// extracted by mini-css-extract-plugin
export default {"container":"Travel_container__4u9P7","title":"Travel_title__Lu7uC","section":"Travel_section__6bvbA","icon":"Travel_icon__7ifjg","textContent":"Travel_textContent__8kMGP"};